export default "__VITE_ASSET__D6b9PUA$__"